<style>
.fc-event-container a {
  width: 10px !important;
  background: var(--db--arrow-down-border);
  float:left;
}
</style>
<template>
  <div>
    <b-modal size="xl" hide-footer id="editDeliverableModal" title="" class="modal-edit-deliverable" @hide="editDeliverableModalHidden"
      @hidden="editDeliverableModalHiddenComplete">
			<EditModal :allContacts="allContacts"  ref="refEditModal" :namespace="namespace" />
		</b-modal>
    <b-modal size="xl" hide-footer id="editProjectModal" title="" class="modal-edit-project" @hide="editProjectModalHidden">
      <EditProjectModal ref="refEditProjectModal"/>
    </b-modal>
    <b-modal size="lg" hide-footer id="editSocialModal" title="Edit Social Deliverable"
      class="modal-edit-social-deliverable" @show="editSocialModalShown" @shown="afterEditSocialModalShown"
      @hide="editSocialModalHidden" @hidden="editSocialModalHiddenComplete" no-close-on-backdrop no-close-on-esc>
      <EditSocialModal :allContacts="allContacts" :tabIndex="tabIndex" ref="refEditSocialModal"
        :namespace="namespace" />
    </b-modal>
    <b-modal size="xl" no-close-on-backdrop no-close-on-esc hide-footer id="editOrganicSocialMediaPlanModal"
			title="Edit Organic Social Media Plan" class="modal-edit-deliverable" @hide="editOrganicSocialModalPlanHidden"
			@hidden="editOrganicSocialModalPlanHiddenComplete" >
			<EditOrganicSocialMediaPlanModal ref="refEditOrganicSocialMediaPlanModal" :tabIndex="tabIndex"
				:namespace="namespace" />
		</b-modal>
    <HeaderControls :myWeek='false' @filterUpdated='filterUpdate' @collapseToggleUpdated='collapseToggleUpdate' :namespace="namespace" />
    <div class="container-fluid">
      <CalendarView 
      :filterQuery="filterQuery" 
      :namespace="namespace" 
      :initialView="initialView" 
      :initialDate="initialDate"
      />
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import HeaderControls from "../components/common/HeaderControls";
import CalendarView from "../components/deliverables/CalendarView";
import EditModal from "../components/deliverables/EditModal";
import EditOrganicSocialMediaPlanModal from "../components/deliverables/EditOrganicSocialMediaPlanModal";
import EditProjectModal from "../components/deliverables/EditProjectModal";
import EditSocialModal from "../components/deliverables/EditSocialModal.vue";

export default {
  data() {
    return {
    	namespace:"",
      filterQuery: {
        query: "",
        filterByDate: false,
        filterByDateCreated: false,
        filterByDateCompleted: false,
        dateRange: {
          startDate: new Date(),
          endDate: new Date()
        },
        dateCreatedRange: {
          startDate: new Date(),
          endDate: new Date()
        },
        dateCompletedRange: {
          startDate: new Date(),
          endDate: new Date()
        },
        status: [],
        outlet: [],
        deliverableType: [],
        tag: [],
        department: [],
        coordinator: []
      },
      expandAll: !this.isMobile(),
      tabIndex: 0,
      windowScrollTop: 0,
      isModalNavigating: false,
      hasModalRoute: false,
      openedDirectlyWithModal: false,
    }
  },
  computed: {
    ...mapGetters([
      "allCustomFields", 
      'allUsers', 
      'allContacts', 
      'deliverableDetail', 
      'projectDetail',
      "calendarFilter",
      "getDeliverableTemplateSlug",
    ]),
    initialView() {
      if (
        this.calendarFilter &&
        this.calendarFilter.calendarViewType &&
        this.calendarFilter.calendarViewType != ""
      ) {
        return this.calendarFilter.calendarViewType;
      } else {
        return 'dayGridWeek';
      }
    },
    initialDate() {
      if (
        this.calendarFilter &&
        this.calendarFilter.listByDateRange &&
        this.calendarFilter.listByDateRange.startDate &&
        this.calendarFilter.listByDateRange.endDate
      ) {
        const startDate = this.$moment(this.calendarFilter.listByDateRange.startDate);
        const endDate = this.$moment(this.calendarFilter.listByDateRange.endDate);
        const duration = this.$moment.duration(endDate.diff(startDate));
        const halfDuration = duration.asMilliseconds() / 2;
        const middleDate = startDate.add(halfDuration, 'milliseconds');
        return middleDate.toDate();
      } else {
        return new Date();
      }
    },
  },
  components: {
    CalendarView,
    HeaderControls,
    EditModal,
		EditOrganicSocialMediaPlanModal,
    EditProjectModal,
		EditSocialModal,
  },
  watch: {
    '$route'(to, from) {
      if (this.isModalNavigating) {
        this.isModalNavigating = false;
        return;
      }
      const deliverableId = to.params.deliverableId;
      if (deliverableId && !this.hasModalRoute) {
        this.hasModalRoute = true;
        this.openDeliverableFromRoute(deliverableId);
      } else if (!deliverableId && this.hasModalRoute) {
        this.hasModalRoute = false;
        this.closeAllModals();
      }
    }
  },
  beforeDestroy() {
		if (this.$bvModal && this.$bvModal.hide) {
      this.$bvModal.hide("editDeliverableModal");
      this.$bvModal.hide("editProjectModal");
			this.$bvModal.hide("editOrganicSocialMediaPlanModal");
			this.$bvModal.hide("editSocialModal");
      this.$bvModal.hide("editRelatedSocialModal");
		}
		document.body.classList.remove("social-modal-open", "social-modal-shown", "social-media");
	},
  created() {
    const path = window.location.pathname;
    const isModalUrl = /\/calendar\/\d+/.test(path);
    const navEntries = performance.getEntriesByType('navigation');
    const navigationType = navEntries.length > 0 ? navEntries[0].type : 'navigate';
    const isReload = navigationType === 'reload';
    if (isModalUrl && !document.referrer && !isReload) {
      this.openedDirectlyWithModal = true;
    }
    this.fetchDepartments()
		this.fetchProjects()
    this.fetchAllCustomFields()
		this.fetchUsers()
    this.fetchActiveUsers()
    /*
		* EditSocialModal needs SystemSettings.languages
		*/
    this.fetchSystemSettings();
  },
  mounted() {
    this.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
			if (modalId == "editDeliverableModal") {
				this.$store.state.deliverables.editDeliverableModal = false;
			} else if (modalId == "editProjectModal") {
				this.$store.state.deliverables.editProjectModal = false;
			}
		})
		this.$root.$on("bv::modal::show", (bvEvent, modalId) => {
			if (modalId == "editDeliverableModal") {
				this.$store.state.deliverables.editDeliverableModal = true;
			}
			if (modalId == "editSocialModal") {
				this.$store.state.deliverables.editSocialModal = true;
			}
		})
		const deliverableId = this.$route.params.deliverableId;
		if (deliverableId) {
			this.hasModalRoute = true;
			this.$nextTick(() => {
				this.openDeliverableFromRoute(deliverableId);
			});
		}
  },
  methods: {
    ...mapActions([
      'fetchDepartments', 
      'fetchProjects', 
      'fetchAllCustomFields', 
      'fetchUsers', 
      'fetchActiveUsers',
      "fetchSystemSettings",
      "getDeliverableDetail",
    ]),
    filterUpdate(filterQuery) {
      this.filterQuery = filterQuery
    },
    async openDeliverableFromRoute(deliverableId) {
      try {
        this.$store.commit(this.namespace + 'setDataLoading', true);
        await this.$store.dispatch("getDeliverableDetail", { deliverableId });
        
        let currentTitle = document.title.match(/\(\d+\)\s/g);
        if(!currentTitle) {
          document.title = this.deliverableDetail.title;
        } else {
          document.title = currentTitle[0] + this.deliverableDetail.title;
        }
        const modalHint = this.$route.query.modal;
        let modalId = "editDeliverableModal";
        
        if (modalHint === 'social') {
          modalId = "editSocialModal";
        } else if (modalHint === 'osmp') {
          modalId = "editOrganicSocialMediaPlanModal";
        } else {
          const template_slug = this.getDeliverableTemplateSlug(parseInt(this.deliverableDetail.deliverable_template_id));
          if (template_slug === "social-media") {
            modalId = "editSocialModal";
          } else if (template_slug === "organic-social-media-plan") {
            modalId = "editOrganicSocialMediaPlanModal";
          }
        }
        
        this.$bvModal.show(modalId);
        this.$store.commit(this.namespace + 'setDataLoading', false);
      } catch (error) {
        console.error('Error loading deliverable:', error);
        this.$store.commit(this.namespace + 'setDataLoading', false);
        this.$router.push({ name: 'calendar' });
      }
    },
    closeAllModals() {
      this.$bvModal.hide('editDeliverableModal');
      this.$bvModal.hide('editSocialModal');
      this.$bvModal.hide('editOrganicSocialMediaPlanModal');
    },
		editDeliverableModalHidden() {
			this.$store.commit('setDeliverable', this.deliverableDetail);
		},
		editDeliverableModalHiddenComplete() {
			if (!this.isModalNavigating && this.$route.params.deliverableId) {
				this.isModalNavigating = true;
				this.hasModalRoute = false;
				if (this.openedDirectlyWithModal) {
					this.openedDirectlyWithModal = false;
					this.navigateToCalendarPage();
				} else {
					this.$router.back();
				}
			}
		},
		editProjectModalHidden() {
			this.$store.commit('setProject', this.projectDetail)
		},
    editSocialModalShown() {
      document.body.classList.add("social-modal-open");
      $("#content").scrollTop(this.windowScrollTop);
    },
    afterEditSocialModalShown() {
      document.body.classList.add("social-modal-shown");
    },
    editSocialModalHidden() {
      this.windowScrollTop = $("#content").scrollTop();
      document.body.classList.remove("social-modal-open");
      document.body.classList.remove("social-modal-shown");
      $(window).scrollTop(this.windowScrollTop);
      this.$store.commit(this.namespace + 'setDeliverable', this.deliverableDetail);
    },
    editSocialModalHiddenComplete() {
      if (!this.isModalNavigating && this.$route.params.deliverableId) {
        this.isModalNavigating = true;
        this.hasModalRoute = false;
        if (this.openedDirectlyWithModal) {
          this.openedDirectlyWithModal = false;
          this.navigateToCalendarPage();
        } else {
          this.$router.back();
        }
      }
    },
    editOrganicSocialModalPlanHidden() {
			this.$store.commit(this.namespace + 'setDeliverable', this.deliverableDetail);
		},
		editOrganicSocialModalPlanHiddenComplete() {
			if (!this.isModalNavigating && this.$route.params.deliverableId) {
				this.isModalNavigating = true;
				this.hasModalRoute = false;
				if (this.openedDirectlyWithModal) {
					this.openedDirectlyWithModal = false;
					this.navigateToCalendarPage();
				} else {
					this.$router.back();
				}
			}
		},
    navigateToCalendarPage() {
      this.$router.push({ name: 'calendar' });
    },
    collapseToggleUpdate(expandAll) {
      this.expandAll = expandAll
    }
  }
};
</script>